export class Role {
    public id: number;
    public libelle: string;
    constructor(id, libelle) {
        this.id = id;
        this.libelle = libelle;
    }
}
